import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Register } from '../../_models/register';
import { Globals } from '../../_models/globals';
import { Router, ActivatedRoute } from '@angular/router';
import { Caller } from '../../_models/caller';
import { User } from '../../_models/user';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { AccessSecurity } from '../../_models/accessSecurity';

@Component({
  selector: 'app-otp2',
  templateUrl: './otp2.component.html',
  styleUrls: ['./otp2.component.scss'],
})
export class Otp2Component implements OnInit {
  companyName: string = "";
  email: string = "";
  emailOtp: string = "";
  id: number = null;
  userPwd: string = "";
  statusText2: string;
  mobileNumber: string = "";
  mobileOtp: string = "";
  password: string = "";
  name: string = "";
  timerDisplayValue: string = "30:00";
  reEnterPassword: string = "";
  errorMessage: string = "";
  successMessage: string = "";
  otpError: string = "";
  otp: string = "";
  confirm: string = "";
  password1: string = "";
  password2: string = "";
  password3: string = "";
  password4: string = "";
  countDown: any = 30;
  interval: any;
  str: any;
  mobile: any;
  totalDuration: number = 60 * 30;
  hide: boolean = true;

  constructor(private http: HttpClient, public g: Globals, public accessSec: AccessSecurity, public route: ActivatedRoute, public user: User, private router: Router, public register: Register, public caller: Caller) {

    if (this.register && this.register.registered) {
      this.register.registered = false;
      this.submitResend();
    }
    this.mobile = this.route.snapshot.params['mobileNumber'];

    this.str = (this.user.mobileNumber);
    this.str = this.str ? this.str.toString().replace(/\d(?=\d{3})/g, "*") : this.str;
  }


  myFunction() {
    this.hide = !this.hide;
  }
  ngOnInit() {
    this.startTimer(this.totalDuration);
  }

  resetAccessSecurity() {
    for (let key of Object.keys(this.accessSec)) {
      this.accessSec[key] = false;
    }
  }

  typePassword() {
    this.statusText2 = "";
    if (this.userPwd == null || this.userPwd === undefined || this.userPwd === '' || this.userPwd === 'undefined') {
      this.statusText2 = 'Please enter Password';
    }
  }

  keytab(event, val1, val2) {
    if (event.key == 'Backspace') {
      document.getElementById(val2).focus();
    } else {
      document.getElementById(val1).focus();
    }
  }

  startTimer(duration) {
    let timer = duration, minutes, seconds;
    let timeNew = this.timerDisplayValue;
    this.interval = setInterval(() => {
      minutes = parseInt(timer / 60 + "", 10)
      seconds = parseInt(timer % 60 + "", 10);
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      this.timerDisplayValue = minutes + ":" + seconds;
      if (--timer < 0) {
        timer = duration;
      }
      //console.log(this.timerDisplayValue);
      //console.log(timerNew);
    }, 1000);
    //console.log(timerNew);
  }

  stopTimerFunction() {
    clearInterval(this.interval);
    this.timerDisplayValue = "30:00";
  }

  verifyOtp() {

    this.otp = this.password1.toString() + this.password2.toString() + this.password3.toString() + this.password4.toString();
    this.successMessage = "";
    this.errorMessage = "";
    if (!this.otp) {
      this.errorMessage = "Please Enter OTP";
    }

    if (this.errorMessage != "") {
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/validateOtp', {
      "mobileNumber": this.caller.parent == "REGISTER" ? this.register.getMobile() : this.user.mobileNumber,
      "otp": this.otp
    },
      { headers: header1 }
    ).subscribe(data => {
      if (data['code'] == 200) {
        this.successMessage = "OTP Created Successfully";
        //this.submitRegistration();
        //this.router.navigate(['/access/warehouseRequest']);
        if (this.caller.parent == "REGISTER") {
          this.router.navigate(['/access/info']);
        } else if (this.caller.parent == "TWO_VERIFICATION") {
          if (this.user.role == 'ROLE_ADMIN') {
            this.router.navigate(['/admin/adminDashboard']);
          } else if (this.user.role == 'DISPATCHER') {
            this.router.navigate(['/admin/dispatchOrders']);
          } else if (this.user.role == 'SUPERVISOR') {
            this.router.navigate(['/admin/adminDashboard']);
          } else if (this.user.role == 'ACCOUNT_OWNER') {
            this.router.navigate(['/admin/dashboard']);
          } else if (this.user.role == 'DEMO_ACCOUNT') {
            this.router.navigate(['/admin/home']);
          } else if (this.user.role == 'DRIVER') {
            this.router.navigate(['/admin/driverDashboard']);
          } else if (this.user.role == 'WORK_MEN' || this.user.role == 'PACKER') {
            this.router.navigate(['/admin/workMenDashboard']);
          } else if (this.user.role == 'RECEIVER' || this.user.role == 'SECURITY') {
            this.router.navigate(['/admin/securityDefault']);
          } else if (this.user.role == 'CUSTOMER_CARE' || this.user.role == 'SALES_MKTG') {
            this.router.navigate(['/admin/adminOrder']);
          } else {
            if (this.accessSec.viewDashboard) {
              this.router.navigate(['/admin/dashboard']);
            } else {
              this.router.navigate(['/admin/myAccountList']);
            }
          }
        }
      } else {
        this.errorMessage = data['message'];
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.errorMessage = "otp Failed, please re-try.";
      }
    )
  }

  verifyWebOtp() {

    this.otp = this.password1.toString() + this.password2.toString() + this.password3.toString() + this.password4.toString();
    this.successMessage = "";
    this.errorMessage = "";
    if (!this.otp) {
      this.errorMessage = "Please Enter OTP";
    }
    if (!this.userPwd) {
      this.statusText2 = "Please Enter Password";
    }
    if (this.errorMessage != "" || this.statusText2 != "") {
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/validatewebotp', {
      "mobileNumber": this.route.snapshot.params['mobileNumber'],
      "otp": this.otp,
      "password": this.userPwd,
      "rememberMe": true,
      "username": this.route.snapshot.params['mobileNumber']
    },
      { headers: header1 }
    ).subscribe(data => {
      if (data['code'] == 200) {
        this.user.role = data['role'];
        this.user.accountOwnerId = data['accountOwnerId'];
        this.user.mobileNumber = data['mobileNumber'];
        this.user.userId = data['userId'];
        this.user.organizationId = data['organizationId'];
        this.user.driverId = data['driverId'];
        this.user.orgUserId = data['orgUserId'];
        this.user.duration = data['duration'];
        this.user.userName = data['userName'];
        this.user.loadedSampleData = data['loadedSampleData'];

        if (this.user.role == 'ROLE_ADMIN') {
          this.user.adminUserId = data['userId'];
          localStorage.setItem('jwt', data['idToken']);
          this.router.navigate(['/admin/adminDashboard']);
        } else if (this.user.role == 'ACCOUNT_OWNER') {
          localStorage.setItem('jwt', data['idToken']);
          this.g.profilePopup = data['postRegData'];
        } else if (this.user.role == 'DISPATCHER') {
          localStorage.setItem('jwt', data['idToken']);
        } else if (this.user.role == 'DEMO_ACCOUNT') {
          localStorage.setItem('jwt', data['idToken']);
          this.g.profilePopup = data['postRegData'];
        } else if (this.user.role == 'DRIVER') {
          localStorage.setItem('jwt', data['idToken']);
        } else if (this.user.role == 'ROLE_USER') {
          localStorage.setItem('jwt', data['idToken']);
          this.assignSecurityValues(data['securityConfigs'], this.user.role);
        } else if (this.user.role == 'SUPERVISOR') {
          localStorage.setItem('jwt', data['idToken']);
        } else if (this.user.role == 'WORK_MEN' || this.user.role == 'PACKER') {
          localStorage.setItem('jwt', data['idToken']);
        } else if (this.user.role == 'RECEIVER' || this.user.role == 'SECURITY') {
          localStorage.setItem('jwt', data['idToken']);
        } else if (this.user.role == 'SALES_MKTG' || this.user.role == 'CUSTOMER_CARE') {
          localStorage.setItem('jwt', data['idToken']);
        } else {
          localStorage.setItem('jwt', data['idToken']);
        }
        this.successMessage = "OTP Created Successfully";
        //this.submitRegistration();
        //this.router.navigate(['/access/warehouseRequest']);
        if (this.caller.parent == "REGISTER") {
          this.router.navigate(['/access/info']);
        } else if (this.user.role == 'ROLE_ADMIN') {
          this.router.navigate(['/admin/adminDashboard']);
        } else if (this.user.role == 'DISPATCHER') {
          this.router.navigate(['/admin/dispatchOrders']);
        } else if (this.user.role == 'SUPERVISOR') {
          this.router.navigate(['/admin/adminDashboard']);
        } else if (this.user.role == 'ACCOUNT_OWNER') {
          this.router.navigate(['/admin/dashboard']);
        } else if (this.user.role == 'DEMO_ACCOUNT') {
          this.router.navigate(['/admin/home']);
        } else if (this.user.role == 'DRIVER') {
          this.router.navigate(['/admin/driverDashboard']);
        } else if (this.user.role == 'WORK_MEN' || this.user.role == 'PACKER') {
          this.router.navigate(['/admin/workMenDashboard']);
        } else if (this.user.role == 'RECEIVER' || this.user.role == 'SECURITY') {
          this.router.navigate(['/admin/securityDefault']);
        } else if (this.user.role == 'CUSTOMER_CARE' || this.user.role == 'SALES_MKTG') {
          this.router.navigate(['/admin/adminOrder']);
        } else {
          if (this.accessSec.viewDashboard) {
            this.router.navigate(['/admin/dashboard']);
          } else {
            this.router.navigate(['/admin/myAccountList']);
          }
        }

      } else {
        this.errorMessage = data['message'];
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.errorMessage = "otp Failed, please re-try.";
      }
    )
  }

  submitRegistration() {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/registerCompany', {
      "companyName": this.register.companyName,
      "email": this.register.email,
      "mobileNumber": this.register.mobile,
      "organizationId": 1,
      "name": this.register.name,
      "password": this.register.password,
      "reEnterPassword": this.register.reEnterPassword
    },
      { headers: header1 }).subscribe(data => {
        this.router.navigate(['/access/warehouseRequest']);
        this.register.Id = data['id'];
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.errorMessage = "Registration Failed, please re-try.";
        }
      )
  }

  submitResend() {
    this.stopTimerFunction();
    this.successMessage = "";
    this.errorMessage = "";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.password1 = "";
    this.password2 = "";
    this.password3 = "";
    this.password4 = "";
    this.http.post(environment.apiUrl + 'api/generateOTP?mobileNumber=' + this.user.mobileNumber + "&organizationId=" + this.user.organizationId,
      {
        headers: header1
      }).subscribe(data => {
        if (data['code'] == 200) {
          this.successMessage = data['message'];
          this.startTimer(this.totalDuration);
        } else {
          this.errorMessage = "invalid otp";
          if (data['code'] == 400) {
            this.errorMessage = data['message'];
          }
        }
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.errorMessage = "Failed OTP Generation, please retry.";
        }
      );
  }

  verifyFPOtp() {
    this.successMessage = "";
    this.errorMessage = "";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.otp = this.password1 + this.password2 + this.password3 + this.password4;
    this.http.post(environment.apiUrl + 'api/validateOTPForResetPwd', {
      "mobileNumber": this.register.mobile,
      "otp": this.otp
    },
      { headers: header1 }
    ).subscribe((data: any) => {
      if (data['code'] == 200) {
        this.successMessage = "OTP Created Successfully";
        this.router.navigate(['/access/resetpassword/' + data.token]);
      } else {
        this.errorMessage = "Invalid OTP";
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.errorMessage = "otp Failed, please re-try.";
      }
    )
  }
  assignSecurityValues(securityValues, role) {
    this.resetAccessSecurity();
    let securityConfigs = [];
    securityConfigs = securityValues;
    for (let sc of securityConfigs) {
      //Dashboard
      if (sc.securityCode == "view-dashboard") {
        this.accessSec.viewDashboard = true;
      }

      // Orders
      if (sc.securityCode == "create-order") {
        this.accessSec.createOrder = true;
      }
      if (sc.securityCode == "edit-order") {
        this.accessSec.editOrder = true;
      }
      if (sc.securityCode == "view-orders") {
        this.accessSec.viewOrders = true;
      }

      //Inventory
      if (sc.securityCode == "add-product") {
        this.accessSec.addProduct = true;
      }
      if (sc.securityCode == "edit-product") {
        this.accessSec.editProduct = true;
      }
      if (sc.securityCode == "delete-product") {
        this.accessSec.deleteProduct = true;
      }
      if (sc.securityCode == "view-products") {
        this.accessSec.viewProducts = true;
      }

      //workOrders
      if (sc.securityCode == "create-work-order") {
        this.accessSec.createWorkOrder = true;
      }
      if (sc.securityCode == "edit-work-order") {
        this.accessSec.editWorkOrder = true;
      }
      if (sc.securityCode == "view-work-orders") {
        this.accessSec.viewWorkOrders = true;
      }

      if (sc.securityCode == "create-inbound-order") {
        this.accessSec.createInboundOrder = true;
      }
      if (sc.securityCode == "edit-inbound-order") {
        this.accessSec.editInboundOrder = true;
      }
      if (sc.securityCode == "view-inbound-orders") {
        this.accessSec.viewInboundOrders = true;
      }
      if (sc.securityCode == "stock-transfer") {
        this.accessSec.stockTransfer = true;
      }

      //addressBook
      if (sc.securityCode == "create-customer") {
        this.accessSec.createCustomer = true;
      }
      if (sc.securityCode == "edit-customer") {
        this.accessSec.editCustomer = true;
      }
      if (sc.securityCode == "view-customers") {
        this.accessSec.viewCustomers = true;
      }

      //invoices
      if (sc.securityCode == "view-invoices") {
        this.accessSec.viewInvoices = true;
      }

      //reports
      if (sc.securityCode == "view-reports") {
        this.accessSec.viewReports = true;
      }

      //my account
      if (sc.securityCode == "view-settings") {
        this.accessSec.viewSettings = true;
      }
      if (sc.securityCode == "edit-settings") {
        this.accessSec.editSettings = true;
      }

      //settings
      if (sc.securityCode == "payment") {
        this.accessSec.payment = true;
      }
      if (sc.securityCode == "shipping-preferences") {
        this.accessSec.shippingPreferences = true;
      }
      if (sc.securityCode == "label-preferences") {
        this.accessSec.labelPreferences = true;
      }
      if (sc.securityCode == "return-preferences") {
        this.accessSec.returnPreferences = true;
      }
    }
  }

}
